

import React, { useEffect, useState } from "react";
import { Button, Form, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import { BiPlusCircle, BiWindowClose } from "react-icons/bi";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { EmissionScope, ExternalDependencyType } from "../../core/constants/common";
import CarbonEmissionService from "../../core/services/CarbonEmissionService";
import './ExternalDependencyPopup.scss';

function ExternalDependencyPopup({
	type,
	config,
	reportingPeriod,
	companyId,
	branchId,
	callbackModal
}) {

	const [materials, setMaterials] = useState([{
		level1: '',
		level2: '',
		level3: '',
		level4: '',
		level5: '',
		quantity: '',
		multiple: '',
		unit: '',
		emission: ''
	}]);
	const [materialsOptions, setMaterialsOptions] = useState({
		level1: [],
		level2: [],
		level3: [],
		level4: [],
		level5: [],
		uoms: []
	});
	const [liveGHGEmission, setLiveGHGEmission] = useState({});
	const [emissionCatDesc, setEmissionCatDesc] = useState('');
	const [emissionTable, setEmissionTable] = useState('DEFRA');
	const [dbData, setDBData] = useState([]);

	useEffect(() => {
		if (type === ExternalDependencyType.EMISSION_CALCULATOR) {
			const r = {
				index: 0,
				level: 1,
				level1: '',
				level2: '',
				level3: '',
				level4: '',
				level5: ''
			};
			getScope(config.emissionScope);
			getLevels(r, config.emissionCategory);
			getDBData();
		}
	}, []);

	const handleClose = () => {
		callbackModal(false);
	};

	const handleConfirm = () => {
		callbackModal(true, getGHGAggregate('kg CO2e'));
	};

	const getTitle = () => {
		if (type === ExternalDependencyType.EMISSION_CALCULATOR) {
			return 'Emission Calculator';
		}
	};

	const renderFormFields = () => {
		if (type === ExternalDependencyType.EMISSION_CALCULATOR) {
			return renderMaterialsQuantity();
		}
		return <></>;
	};

	const renderMaterialsQuantity = () => {
		if (config.emissionCategory === '') return <></>;

		return (
			<div className="Emission_Calculator_modalCard">
				<div className="Emission_Calculator_modalCard_in">
					<div className="scope_1">
					{
						config.emissionScope === EmissionScope.SCOPE_1.label ? EmissionScope.SCOPE_1.text 
						: config.emissionScope === EmissionScope.SCOPE_2.label ? EmissionScope.SCOPE_2.text 
						: EmissionScope.SCOPE_3.text
					}
					</div>
					<div className="source_emission">{emissionCatDesc}</div>
				</div>
				<div className="row">
					<div className="col-lg-2">
						<label htmlFor="emissionTable">Emission Table</label>
						<select id="emissionTable"
							className="form-select"
							onChange={(e) => setEmissionTable(e.target.value)}
							required
							value={emissionTable}>
							{
								dbData.map(d => {
									return <option key={d} value={d}>{d}</option>;
								})
							}
						</select>
					</div>					
				</div>
				<div className="p-0 py-2">
					<h6>Enter the quantity of materials used for the selected source of emission</h6>
					<div className="mt-3">
						<div className="d-flex">
							<div className="w-10 mx-2">Level 1</div>
							<div className="w-10 mx-2">Level 2</div>
							<div className="w-10 mx-2">Level 3</div>
							<div className="w-15 mx-2">Level 4,5</div>
							<div className="w-15 mx-2">Quantity</div>
							<div className="w-15 mx-2">Unit</div>
							<div className="w-15 mx-2 Carbon_Emission_head">Carbon Emission (kg CO2e)</div>
							<div className="w-10"></div>
						</div>
						{
							materials?.map((material, index) => {
								return renderMaterialFormRow(material, index);
							})
						}
					</div>
				</div>

			</div>
		)
	};

	const renderMaterialFormRow = (material, index) => {
		return (
			<Form id={`matFormRow-${index}`} key={`matFormRow-${index}`}>
				<div className="d-flex material-row my-2 w-100" id={`matRow-${index}`} key={`matRow-${index}`}>
					<div className="w-10 mx-2">
						<select
							className="form-select"
							onChange={(e) => onLevel1Change(e.target.value, index)}
							required={true}
							value={material.level1}>
							<option key='' value=''>Select</option>
							{
								materialsOptions.level1?.length > 0 &&
								materialsOptions.level1[index]?.map((l, lindex) => {
									return (
										<option value={l} key={`level1-${index}-${lindex}`}>{l}</option>
									);
								})
							}
						</select>
					</div>
					<div className="w-10 mx-2">
						<select
							className="form-select"
							onChange={(e) => onLevel2Change(e.target.value, index)}
							required={true}
							value={material.level2}>
							<option key='' value=''>Select</option>
							{
								materialsOptions.level2?.length > 0 &&
								materialsOptions.level2[index]?.map((l, lindex) => {
									return <option value={l} key={`level2-${index}-${lindex}`}>{l}</option>;
								})
							}
						</select>
					</div>
					<div className="w-10 mx-2">
						<select
							className="form-select"
							onChange={(e) => onLevel3Change(e.target.value, index)}
							required={true}
							value={material.level3}>
							<option key='' value=''>Select</option>
							{
								materialsOptions.level3?.length > 0 &&
								materialsOptions.level3[index]?.map((l, lindex) => {
									return <option value={l} key={`level3-${index}-${lindex}`}>{l}</option>;
								})
							}
						</select>
					</div>
					<div className="w-15 mx-2">
						<div className="d-flex w-100">
							<div className="w-50 me-1">
								<select
									className="form-select"
									onChange={(e) => onLevel4Change(e.target.value, index)}
									required={true}
									value={material.level4}>
									<option key='' value=''>Select</option>
									{
										materialsOptions.level4?.length > 0 &&
										materialsOptions.level4[index]?.map((l, lindex) => {
											return <option value={l} key={`level4-${index}-${lindex}`}>{l}</option>;
										})
									}
								</select>
							</div>
							<div className="w-50">
								<select
									className="form-select"
									onChange={(e) => onLevel5Change(e.target.value, index)}
									required={true}
									value={material.level5}>
									<option key='' value=''>Select</option>
									{
										materialsOptions.level5?.length > 0 &&
										materialsOptions.level5[index]?.map((l, lindex) => {
											return <option value={l} key={`level5-${index}-${lindex}`}>{l}</option>;
										})
									}
								</select>
							</div>
						</div>						
					</div>
					{
						material.customFields?.length > 1
						?
						<div className="mx-2 w-15">
							<div className="d-flex w-100">
								<div className="w-50 me-1">
									<OverlayTrigger
										placement="top"
										overlay={<Tooltip id="button-tooltip-0">{material.customFields[0]}</Tooltip>}>
										<input className="form-control"
										placeholder={material.customFields[0]}		
											required={true}
											type="number"
											value={material.quantity}
											onWheel={(e) => e.preventDefault()}
											onChange={(e) => onQuantityChange(e.target.value, index)}
											onBlur={(e) => onQuantityBlur(e.target.value, index)} />
									</OverlayTrigger>
								</div>
								<div className="w-50 me-1">
									<OverlayTrigger
										placement="top"
										overlay={<Tooltip id="button-tooltip-1">{material.customFields[1]}</Tooltip>}>
										<input className="form-control"
										placeholder={material.customFields[1]}		
											required={true}
											type="number"
											value={material.multiple}
											onWheel={(e) => e.preventDefault()}
											onChange={(e) => onMultipleChange(e.target.value, index)}
											onBlur={(e) => onMultipleBlur(e.target.value, index)} />
									</OverlayTrigger>
								</div>
							</div>
						</div>
						:
						<div className="w-15 mx-2">
							<input className="form-control"
								required={true}
								type="number"
								value={material.quantity}
								onWheel={(e) => e.preventDefault()}
								onChange={(e) => onQuantityChange(e.target.value, index)}
								onBlur={(e) => onQuantityBlur(e.target.value, index)} />
						</div>
					}					
					<div className="w-15 mx-2">
						<select id="esgFilter"
							className="form-select"
							onChange={(e) => onUnitChange(e.target.value, index)}
							required={true}
							value={materials[index].unit}>
							<option key='' value=''>Select</option>
							{
								materialsOptions.uoms?.length > 0 &&
								materialsOptions.uoms[index]?.map((uom, uindex) => {
									return <option value={uom} key={`uom-${index}-${uindex}`}>{uom}</option>;
								})
							}
						</select>
					</div>
					<div className="w-15 mx-2">
						<input className="form-control"
							required={true}
							disabled={true}
							value={material.emission}
							onChange={null} />
					</div>
					<div className="w-10 action-cell">
						{
							materials?.length > 1 &&
							<span className="mx-1 cursor"
								onClick={() => onDeleteRow(index)}>
								<AiOutlineCloseCircle />
							</span>
						}
						{
							index === (materials?.length - 1) &&
							<span className="mx-1 cursor"
								onClick={() => onAddRow(index)}>
								<BiPlusCircle />
							</span>
						}
					</div>
				</div>
			</Form>
		);
	};

	const onLevel1Change = (val, index) => {
		const row = {
			index: index,
			level: 2,
			level1: val,
			level2: '',
			level3: '',
			level4: '',
			level5: ''
		};
		const matData = JSON.parse(JSON.stringify(materials));
		matData[index].level1 = val;
		matData[index].level2 = '';
		matData[index].level3 = '';
		matData[index].level4 = '';
		matData[index].level5 = '';
		matData[index].quantity = '';
		matData[index].multiple = '';
		matData[index].unit = '';
		matData[index].emission = '';
		setMaterials(matData);
		getLevels(row, config.emissionCategory);
	};

	const onLevel2Change = (val, index) => {
		const row = {
			index: index,
			level: 3,
			level1: materials[index].level1,
			level2: val,
			level3: '',
			level4: '',
			level5: '',
		};
		const matData = JSON.parse(JSON.stringify(materials));
		matData[index].level2 = val;
		matData[index].level3 = '';
		matData[index].level4 = '';
		matData[index].level5 = '';
		matData[index].quantity = '';
		matData[index].multiple = '';
		matData[index].unit = '';
		matData[index].emission = '';
		setMaterials(matData);
		getLevels(row, config.emissionCategory);
	};

	const onLevel3Change = (val, index) => {
		const row = {
			index: index,
			level: 4,
			level1: materials[index].level1,
			level2: materials[index].level2,
			level3: val,
			level4: '',
			level5: '',
		};
		const matData = JSON.parse(JSON.stringify(materials));
		matData[index].level3 = val;
		matData[index].level4 = '';
		matData[index].level5 = '';
		matData[index].quantity = '';
		matData[index].multiple = '';
		matData[index].unit = '';
		matData[index].emission = '';
		setMaterials(matData);
		getLevels(row, config.emissionCategory);
		getUOMs({ level3: val, index: index });
	};

	const onLevel4Change = (val, index) => {
		const row = {
			index: index,
			level: 5,
			level1: materials[index].level1,
			level2: materials[index].level2,
			level3: materials[index].level3,
			level4: val,
			level5: '',
		};
		const matData = JSON.parse(JSON.stringify(materials));
		matData[index].level4 = val;
		matData[index].level5 = '';
		matData[index].quantity = '';
		matData[index].multiple = '';
		matData[index].unit = '';
		matData[index].emission = '';
		setMaterials(matData);
		getLevels(row, config.emissionCategory);
		getUOMs({ level4: val, index: index });
	};

	const onLevel5Change = (val, index) => {
		const matData = JSON.parse(JSON.stringify(materials));
		matData[index].level5 = val;
		matData[index].quantity = '';
		matData[index].multiple = '';
		matData[index].unit = '';
		matData[index].emission = '';
		setMaterials(matData);
		getUOMs({ level5: val, index: index });
	};

	const getUOMs = ({ level3, level4, level5, index }) => {
		CarbonEmissionService.getUOM({
			db: emissionTable,
			scope: config.emissionScope,
			level1: materials[index].level1,
			level2: materials[index].level2,
			level3: level3 ?? materials[index].level3,
			level4: level4 ?? materials[index].level4,
			level5: level5 ?? materials[index].level5
		}).then(res => {
			if (res.status !== 200) return;

			const uoms = res.data.data;
			const matOptions = JSON.parse(JSON.stringify(materialsOptions));
			matOptions.uoms[index] = uoms;
			setMaterialsOptions(matOptions);
		}).catch(err => { });
	};

	const onUnitChange = (val, index) => {
		const matData = JSON.parse(JSON.stringify(materials));
		matData[index].unit = val;
		setMaterials(matData);
		getLiveData(index, null, val);
	};

	const onQuantityChange = (val, index) => {
		const matData = JSON.parse(JSON.stringify(materials));
		matData[index].quantity = val;
		setMaterials(matData);
	};

	const onQuantityBlur = (val, index) => {
		getLiveData(index, val, null);
	};

	const onMultipleChange = (val, index) => {
		const matData = JSON.parse(JSON.stringify(materials));
		matData[index].multiple = val;
		setMaterials(matData);
	};

	const onMultipleBlur = (val, index) => {
		getLiveData(index, null, null, val);
	};

	const onDeleteRow = (index) => {
		const matData = JSON.parse(JSON.stringify(materials));
		matData.splice(index, 1);
		setMaterials(matData);
		const matOptions = JSON.parse(JSON.stringify(materialsOptions));
		matOptions.level1.splice(index, 1);
		matOptions.level2.splice(index, 1);
		matOptions.level3.splice(index, 1);
		matOptions.level4.splice(index, 1);
		matOptions.level5.splice(index, 1);
		matOptions.uoms.splice(index, 1);
		setMaterialsOptions(matOptions);
		const liveData = JSON.parse(JSON.stringify(liveGHGEmission));
		Object.keys(liveData)?.forEach(d => {
			const indexKeys = Object.keys(liveData[d]);
			indexKeys?.forEach(iKey => {
				if (+iKey !== index) return;

				delete liveData[d][iKey];
			});
		});
		setLiveGHGEmission(liveData);
	};

	const onAddRow = (index) => {
		if (!materials[index].level1 || !materials[index].level2 || !materials[index].level3
			|| materials[index].quantity === '' || materials[index].emission === '') {
			// validateRows(index);
			return;
		}
		const matData = JSON.parse(JSON.stringify(materials));
		matData.push({
			level1: '',
			level2: '',
			level3: '',
			level4: '',
			level5: '',
			quantity: '',
			mulitple: '',
			unit: '',
			emission: ''
		});
		setMaterials(matData);
		const matOptions = JSON.parse(JSON.stringify(materialsOptions));
		matOptions.level1.push([]);
		matOptions.level2.push([]);
		matOptions.level3.push([]);
		matOptions.level4.push([]);
		matOptions.level5.push([]);
		matOptions.uoms.push([]);
		setMaterialsOptions(matOptions);
		const row = {
			index: index + 1,
			level: 1,
			level1: '',
			level2: '',
			level3: '',
			level4: '',
			level5: '',
		};
		getLevels(row, config.emissionCategory);
	};

	const getLiveData = (index, quantityVal = null, unitVal = null, multipleVal = null) => {
		const material = materials[index];
		const payload = {
			branchId: branchId,
			scope: config.emissionScope,
			category: config.emissionCategory,
			level1: material.level1,
			level2: material.level2,
			level3: material.level3,
			level4: material.level4 ? material.level4 : null,
			level5: material.level5 ? material.level5 : null,
			uomBeforeConversion: unitVal ? unitVal : material.unit,
			db: emissionTable,
			valueBeforeConversion: quantityVal ? +quantityVal : +material.quantity,
			multiple: multipleVal ? +multipleVal: +material.multiple,
			period: reportingPeriod,
			companyId: companyId
		};
		CarbonEmissionService.getLiveData(payload).then(res => {
			if (res.status !== 200) return;

			const data = res.data.data;
			const liveData = JSON.parse(JSON.stringify(liveGHGEmission));
			let emission = '';
			data?.forEach(d => {
				if (!liveData[`${d.ghgUnit}`]) {
					liveData[`${d.ghgUnit}`] = {};
				}
				liveData[`${d.ghgUnit}`][index] = [d.solution];
				if (d.ghgUnit === 'kg CO2e') {
					emission = d.solution;
				}
			});
			setLiveGHGEmission(liveData);
			setMaterials(mData => {
				const matData = JSON.parse(JSON.stringify(mData));
				matData[index].emission = emission;
				return matData;
			});
		}).catch(err => { });
	};

	const getLevels = (row, cat) => {
		CarbonEmissionService.getLevels({
			db: emissionTable,
			scope: config.emissionScope,
			category: cat,
			level: row.level,
			level1: row.level1,
			level2: row.level2,
			level3: row.level3,
			level4: row.level4,
			level5: row.level5,
		}).then(res => {
			if (res.status !== 200) return;

			const options = res.data.data;
			setMaterialsOptions(moptions => {
				const matOptions = JSON.parse(JSON.stringify(moptions));
				if (row.level === 1) {
					matOptions.level1[row.index] = options;
				} else if (row.level === 2) {
					matOptions.level2[row.index] = options;
				} else if (row.level === 3) {
					matOptions.level3[row.index] = options;
				} else if (row.level === 4) {
					matOptions.level4[row.index] = options;
				} else if (row.level === 5) {
					matOptions.level5[row.index] = options;
				}
				return matOptions;
			});
		}).catch(err => { });
	};

	const getGHGAggregate = (key) => {
		let total = 0;
		const indexKeys = Object.keys(liveGHGEmission[key]);
		indexKeys?.forEach(iKey => {
			liveGHGEmission[key][iKey]?.forEach(d => total += d);
		});
		return Number(total?.toFixed(2));
	};

	const renderFooter = () => {
		const keys = Object.keys(liveGHGEmission);
		if (keys?.length === 0) return <></>;

		return (
			<div className="row m-0 source_emission_row">
				<div className="col-lg-3 p-0">
					<div className="source_emission-AllCount">
						{
							<div key={`footerItemKG`} id={`footerItemKG`}>
								<div className="Emission_totalCount_01">
									<h4 className="text-primary fw-bold m-0">
										{getGHGAggregate('kg CO2e')}
									</h4>
									<span>kg CO2e	</span>
								</div>
								<div className="fw-bold">Total Carbon Emission</div>
							</div>
						}
					</div>
				</div>
			</div>
		)
	};

	const getScope = (scope) => {
		CarbonEmissionService.getCategories(scope).then(res => {
			if (res.status !== 200) return;

			const cat = res.data?.data?.find(c => c.category === config.emissionCategory);
			setEmissionCatDesc(cat?.description ?? '');
		}).catch(err => { });
	};


	const getDBData = () => {
		CarbonEmissionService.getDB().then(res => {
			if (res.status !== 200) return;

			setDBData(res.data.data ?? []);
			if (res.data.data?.length > 0) {
				setEmissionTable(res.data.data[0]);
			}
		}).catch(err => {});
	};

	return (
		<>
			<Modal show={true} dialogClassName="modal-90w" onHide={handleClose}>
				<Modal.Header closeButton>
					<Modal.Title className="h5">{getTitle()}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{renderFormFields()}
					{renderFooter()}
				</Modal.Body>
				<Modal.Footer>
					<Button variant="secondary" onClick={handleClose} autoFocus>
						Cancel
					</Button>
					<Button variant="primary" onClick={handleConfirm} className="sbmBtn">
						Apply
					</Button>
				</Modal.Footer>
			</Modal>
		</>
	);
}

export default ExternalDependencyPopup;
